import { Steps } from '../../steps-model';
import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { TourService } from '../../../services/tour.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-modal-tour',
  templateUrl: './modal-tour.component.html',
  styleUrls: ['./modal-tour.component.scss']
})
export class ModalTourComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('modalWindow') modalWindow: ElementRef;

  showedStep: Steps;
  currentStep: number;
  stepsCount: number;
  isShowed = false;
  positionStyles: object;
  debounceTimer;
  arrow: string;
  helpIcons = [];
  tooltips = [];

  private showStepSubscription$: Subscription;
  private openTourSubscription$: Subscription;

  footerHelpPos: object;

  constructor(private ts: TourService) {}

  ngOnInit() {
    // Get step element
    this.showStepSubscription$ = this.ts.showCurrentStep.subscribe( (stepItem: Steps) => {
        this.showedStep = stepItem;
        this.currentStep = stepItem.step;

        this.arrow = `arrow-step-${stepItem.step} arrow`;

        if (this.showedStep.step === 2) {
          const el: HTMLElement = document.getElementsByClassName('tab-2-open')[0] as HTMLElement;
          el.click();
        } else {
          const el: HTMLElement = document.getElementsByClassName('tab-1-open')[0] as HTMLElement;
          el.click();
        }
        if (this.showedStep.step === 3) {
          setTimeout(function () {
            (<any>$('.manage-project')).dropdown('toggle');
          }, 0);
        } else if (this.showedStep.step === 4) {
          setTimeout(function () {
            (<any>$('#bright-control')).dropdown('toggle');
          }, 0);
        }
        setTimeout( () => {
          this.setModalPosition();
          if (this.showedStep.step >= 4 && this.showedStep.step <= 6) {
            this.setTooltipsPos(this.currentStep); // Get tooltips position for 4-6 steps
          }
        }, 0);
      }
    );
    // Show or hide overlay
    this.openTourSubscription$ = this.ts.open.subscribe(
      value => {
        this.isShowed = value;
      }
    );
  }

  ngAfterViewInit() {
    setTimeout( () => {
      this.stepsCount = this.ts.getStepsCount();
      this.setIconHelpPos();
    }, 0 );
  }

  goToStep(n) {
    this.ts.goToStep(n);
  }

  onResize(event) {
    if (this.showedStep) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout( () => {
        this.setModalPosition();
        this.setIconHelpPos();
        this.setTooltipsPos(this.currentStep);
      }, 500 );
    }
  }

  goBack() {
    this.ts.previousStep();
  }

  goNext() {
    this.ts.nextStep();
  }

  close() {
    this.ts.closeTour();
  }

  setTooltipsPos(index) {
    this.tooltips = [];

    if (index >= 4 && index <= 6) {
      const tooltipsArr = this.ts.getTooltipsPos(index);

      for (let i = 0, l = tooltipsArr.length; i < l; i++) {
        this.tooltips[i] = {
          top: tooltipsArr[i].top + 'px',
          left: tooltipsArr[i].left + 'px',
        };
      }
    }
  }

  setIconHelpPos() {
    const itemsHelpArr = this.ts.getPosHelp();

    for (let i = 0, l = itemsHelpArr.length; i < l; i++) {
      const itemHelp = itemsHelpArr.find((item) => item.step === i + 1);
      if (itemHelp) {
        this.helpIcons[i] = {
          top: itemHelp.top + 'px',
          left: itemHelp.left + 'px'
        };
      } else {
        this.helpIcons[i] = {};
        console.error('ItemHelp is undefined');
      }
    }
  }

  setModalPosition() {
    const pos = this.showedStep.position;

    // Get first element from elements[]
    const el = this.showedStep.elements[0].nativeElement;

    // Get modal width and height for offsets
    const modalHeight = this.modalWindow.nativeElement.clientHeight;
    const modalWidth = this.modalWindow.nativeElement.clientWidth;

    let currentOffsetLeft = el.offsetLeft;
    let currentOffsetTop = el.offsetTop;

    // For steps 3-7 - position of parent element of each step is absolute
    // Step elements calculate offset from it parent element
    // We need to get parent's element offset to set correct position for modal
    if (this.showedStep.step === 3) {
      const parentOffsetLeft = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                parentElement.
                                                parentElement.
                                                offsetLeft;

      currentOffsetTop += 25;
      currentOffsetLeft += parentOffsetLeft + 40;
    }
    if (this.showedStep.step === 4) {
      const parentOffsetLeft = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                parentElement.
                                                parentElement.
                                                offsetLeft;

      currentOffsetTop += 150;
      currentOffsetLeft += parentOffsetLeft + 300;
    }

    if (this.showedStep.step === 5) {
      const parentOffsetLeft = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                parentElement.
                                                offsetLeft;

      currentOffsetTop += 140;
      currentOffsetLeft += parentOffsetLeft + 215;
    }

    if (this.showedStep.step === 6) {
      const parentOffsetLeft = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                offsetLeft;
      const parentOffsetTop = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                offsetTop;

      currentOffsetTop += parentOffsetTop;
      currentOffsetLeft += parentOffsetLeft - 10;
    }

    if (this.showedStep.step === 7) {
      const parentOffsetLeft = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                offsetLeft;
      const parentOffsetTop = this.showedStep.elements[0]
                                                .nativeElement.
                                                parentElement.
                                                offsetTop;

      currentOffsetTop += parentOffsetTop;
      currentOffsetLeft += parentOffsetLeft + 80;
    }

    if (modalHeight === 0) {
      setTimeout( () => this.setModalPosition(), 0);
      return;
    }

    // Set coordinates for modal
    switch (pos) {
      case 'top': {
        // console.log('MODAL top');
        this.positionStyles = {
          top : currentOffsetTop - modalHeight - 20 + 'px',
          left: currentOffsetLeft  + 'px'
        };
      } break;
      case 'right': {
        // console.log('MODAL right');
        this.positionStyles = {
          top : el.offsetHeight / 2 + 'px',
          left: el.offsetLeft + el.offsetWidth  + 20 + 'px'
        };
      } break;
      case 'bottom': {
        // console.log('MODAL bottom');
        this.positionStyles = {
          top : currentOffsetTop + el.clientHeight + 20 + 'px',
          left: currentOffsetLeft - (el.offsetLeft / 4) + 20 + 'px'
        };
      } break;
      case 'left': {
        // console.log('MODAL left');
        this.positionStyles = {
          top : el.offsetTop  + 'px',
          left: el.offsetLeft - modalWidth - 20 + 'px'
        };
      } break;
      default: {
        // console.log('NO POSITION');
        this.positionStyles = {
          top : el.offsetHeight / 4 + 'px',
          left: el.offsetLeft + el.offsetWidth + 20 + 'px',
        };
      }
    }
  }

  ngOnDestroy() {
    this.showStepSubscription$.unsubscribe();
    this.openTourSubscription$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-tour/modal-tour.component.ts